import * as React from "react";
import { SnapshotCollection } from "@/modules/snapshots/snapshotCollection.types";
import clsx from "clsx";
import { SnapshotCollectionsRowMenu } from "./row-menu";

interface Props {
  snapshotCollection: SnapshotCollection;
  isSelected: boolean;
  handleSelect: (collection: SnapshotCollection) => void;
}

export const SnapshotCollectionsRow: React.FC<Props> = ({ snapshotCollection, isSelected, handleSelect }) => (
  <div
    onClick={() => handleSelect(snapshotCollection)}
    className={clsx(
      "group relative flex h-full w-full max-w-[450px] cursor-pointer flex-col rounded-xl border border-gray-200 bg-ui-card-background p-4 transition-all hover:border-desert-sand-300 hover:shadow-xl sm:p-5 md:p-6",
      {
        "border-desert-sand-300 shadow-xl": isSelected,
      },
    )}
  >
    <div className="flex items-start gap-2">
      <div className="min-w-0 flex-1 space-y-2">
        <h5 className="break-words font-semibold leading-tight text-gray-900 transition-colors group-hover:text-midnight-blue-600">
          <SnapshotCollectionsRowMenu snapshotCollection={snapshotCollection} />
        </h5>
        <span className="bg-desert-sand-100/50 inline-flex items-center whitespace-nowrap rounded-md text-xs text-desert-sand-800 sm:text-sm">
          {snapshotCollection.snapshots} Snapshots
        </span>
      </div>
    </div>
  </div>
);
